import { IAnnualReport, IFinStatements } from '@modeso/types__aumico-lib-annualreport-be';
import { AnnualReportVisitor } from '../AnnualReportsVisitor';

export class TranslatedAnnualReport {
    constructor(private annualReport: IAnnualReport, private finStatements: IFinStatements[]) {}

    accept(annualReportVisitor: AnnualReportVisitor) {
        annualReportVisitor.visit(this.annualReport, this.finStatements);
    }
}
